import { render, staticRenderFns } from "./FooterForUpdate.vue?vue&type=template&id=359641b1&scoped=true&"
import script from "./FooterForUpdate.vue?vue&type=script&lang=js&"
export * from "./FooterForUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FooterForUpdate.vue?vue&type=style&index=0&id=359641b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359641b1",
  null
  
)

export default component.exports